// extracted by mini-css-extract-plugin
export default {"dialog_version":"VersionModalDelete_dialog_version__mLlK4","btn_cancel":"VersionModalDelete_btn_cancel__eYdKh","btn_delete":"VersionModalDelete_btn_delete__lRfb2"};